// eslint-disable-next-line import/order
import { toast } from "react-toastify";
import { NOTIFICATION_MESSAGE_TYPE } from "../../constants/variables";

export function displayToastNotification(messageType: string, message: string) {
  if (messageType === NOTIFICATION_MESSAGE_TYPE.ERROR) {
    toast.error(message, { position: toast.POSITION.TOP_RIGHT });
  } else if (messageType === NOTIFICATION_MESSAGE_TYPE.SUCCESS) {
    toast.success(message, { position: toast.POSITION.TOP_RIGHT });
  } else {
    toast.error(message, { position: toast.POSITION.TOP_RIGHT });
  }
}
